import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {LocalStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-zip-code',
  templateUrl: 'zip-code.component.html',
  styleUrls: ['zip-code.component.scss'],
})
export class ZipCodeComponent implements OnInit {

  zipCodes: any = [];
  zipCodeMatched = 1;
  zipCodeForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private localSt: LocalStorageService) {
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.zipCodeForm = new FormGroup({
      zipCodeField	: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
    });
  }

  closeModal(status) {
    this.activeModal.close(status);
  }

  checkZipFunction() {
    this.zipCodes = this.localSt.retrieve('zipCodes');
    for (let i = 0; i < this.zipCodes.length; i++) {
      const item = this.zipCodes[i];
      if (Number(item.zf_zip_code) === Number(this.zipCodeForm.value.zipCodeField)) {
        this.zipCodeMatched = 2;
        this.localSt.store('validZipCode', item.zf_zip_code);
        break;
      } else {
        this.zipCodeMatched = 3;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/zip-code/zip-code.component.ts